// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState } from 'react';
import { StyledMobileBoxItemRow } from '../utils/Styles/DataBoxStyles';
import { isMobileResolution } from '../../infrastructure/utils/common';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import CollapsableItem from '../utils/CollapsableItem';
import ActivityEditMobileActions from './ActivityEditMobileAction';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivityPopularityMobile = ({ activity }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [values, setValues] = useState({
    popularity: 'higher is sorted first',
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    bachelorPopularity: activity.bachelorPopularity,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    bachelorettePopularity: activity.bachelorettePopularity,
  });

  const onChange = (key, value) => {
    setValues({
      ...values,
      [key]: value,
    });
  };

  if (!isMobileResolution()) return null;
  return (
    <div className='data-box'>
      <h4 className='header' style={{ display: 'flex', alignItems: 'center' }}>
        Popularity
        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <ActivityEditMobileActions
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
          />
        }
      </h4>
      <CollapsableItem>
        <StyledMobileBoxItemRow maxWidth='100%'>
          Popularity:
          {isEditMode ? (
            <input
              type='text'
              value={values.popularity}
              onChange={e => onChange('popularity', e.target.value)}
            />
          ) : (
            <span>{values.popularity}</span>
          )}
        </StyledMobileBoxItemRow>
        <StyledMobileBoxItemRow maxWidth='100%'>
          Bachelor Popularity:
          {isEditMode ? (
            <input
              type='text'
              value={values.bachelorPopularity}
              onChange={e => onChange('bachelorPopularity', e.target.value)}
            />
          ) : (
            <span>{values.bachelorPopularity}</span>
          )}
        </StyledMobileBoxItemRow>
        <StyledMobileBoxItemRow maxWidth='100%'>
          Bachelorette Popularity:
          {isEditMode ? (
            <input
              type='text'
              value={values.bachelorettePopularity}
              onChange={e => onChange('bachelorettePopularity', e.target.value)}
            />
          ) : (
            <span>{values.bachelorettePopularity}</span>
          )}
        </StyledMobileBoxItemRow>
      </CollapsableItem>
    </div>
  );
};

export default ActivityPopularityMobile;
